const bank = {
    getlist: 'bank/getlist-by-admin',
    add: 'bank/add',
    update: 'bank/update',
    remove: 'bank/remove',
}
export default bank
